<app-flock-overview-week-registration-card
  [title]="title()"
  [actions]="cardActions()"
  [items]="cardItems()"
>
</app-flock-overview-week-registration-card>
